import { Either } from "fp-ts/lib/Either";
import MasterItemEntity from "../entities/MasterItemEntity";
import ErrorEntity from "../entities/ErrorEntity";
import GraphDataEntity from "../entities/GraphDataEntity";


export interface BasicDashboardData {
    workedHours: GraphDataEntity[];
    assistedShifts: GraphDataEntity[];
    noAssistedShifts: GraphDataEntity[];
}

export default interface DashboardRepository {
    getBasicData: () => Promise<Either<ErrorEntity, BasicDashboardData>>;
}

export const DashboardRepositoryName = "DashboardRepository";